import axios from 'axios'
import router from '@/router'
import store from '@/store'

var refreshPromise = null

const headers = {
  'Content-type': 'application/json',
  'access-control-allow-origin': '*'
}

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: process.env.VUE_APP_API_TIMEOUT,
  headers
})

const auth = (config) => {
  const accessToken = store.getters['auth/accessToken']
  const tempToken = store.getters['auth/temporalToken']
  if (accessToken) {
    const aux = config.headers ? { ...config.headers } : {}
    config.headers = Object.assign(aux, {
      Authorization: 'Bearer ' + store.getters['auth/accessToken'],
      'accept-language': store.getters['auth/locale'] || 'es'
    })
  } else if (tempToken) {
    const aux = config.headers ? { ...config.headers } : {}
    config.headers = Object.assign(aux, {
      Authorization: 'Bearer ' + store.getters['auth/temporalToken']
    })
  }
  return config
}

const refreshTokenOrFail = async error => {
  if (error.status === null || error.status === undefined) {
    // error.status = 401
  }
  if (!error.response) {
    return Promise.reject(error)
  }
  const { config, response: { status } } = error
  const originalRequest = config

  if (status === 401) {
    if (!refreshPromise) {
      refreshPromise = refreshToken(originalRequest)
        .finally(() => { refreshPromise = null })
    }
    return refreshPromise.then((token) => {
      originalRequest.headers.Authorization = 'Bearer ' + token
      return axios.request(originalRequest)
    })
  } if (status === 403) {
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({ respuesta: null, blnError: true, codError: status, msgError: error.response.data })
  } else {
    store.commit('setIsLoading', false)
    store.commit('setAjaxRequestPending', false)
    store.commit('setLastAjaxResult', 'ko')
  }

  return Promise.reject(error)
}

const refreshToken = async originalRequest => {
  const rtoken = store.getters['auth/refreshToken']
  const atoken = store.getters['auth/accessToken']
  const oldToken = originalRequest.headers?.Authorization?.replace('Bearer ', '')
  if (!rtoken || !atoken) {
    throw (new Error())
  }
  if (atoken !== oldToken) {
    return (atoken)
  }
  
  const uri = process.env.VUE_APP_API_URL + 'api/login/refresh'
  const data = {
    // Token: store.getters['auth/refreshToken']
  }
  return axios.post(uri, data, {
    headers: {
      Authorization: 'Bearer ' + rtoken
    }
  }).then((response) => {
    if (response.status === 200) {
      if (response.data) {
        const accessToken = response.data.AccessToken
        const refreshToken = response.data.RefreshToken
        if (accessToken !== null && refreshToken !== null) {
          store.commit('auth/setTokens', { accessToken, refreshToken })
          return (accessToken)
        }
      }
      return Promise.reject(new Error())
    }
  }).catch((error) => {
    clearTokensAndReturnToLogin(originalRequest)
    throw (error)
  })
}

// Actualización de token de acceso, para llamadas que no son interceptadas por axios (ej: deep-chat)
export const refreshAccessToken = async () => {
  try {
    const uri = process.env.VUE_APP_API_URL + 'api/login/refresh'
    const rtoken = store.getters['auth/refreshToken']
    const response = await axios.post(uri, null, {
      headers: {
        Authorization: 'Bearer ' + rtoken
      }
    })
    if (response?.status === 200 && response?.data?.AccessToken) {
      const accessToken = response.data.AccessToken
      const refreshToken = response.data.RefreshToken
      store.commit('auth/setTokens', { accessToken, refreshToken })
      return accessToken
    }
    throw new Error()
  } catch (err) {
    clearTokensAndReturnToLogin()
    throw err
  }
}

const clearTokensAndReturnToLogin = (a) => {
  store.commit('auth/removeUser')
  store.commit('auth/removeTokens')
  const currentRoute = router.currentRoute
  const returnurl = currentRoute.name !== process.env.VUE_APP_REDIRECT_LOGGED_IN ? btoa(currentRoute.fullPath) : null
  const route = {
    name: process.env.VUE_APP_REDIRECT_FAILED_AUTHENTICATION, 
    params: { refreshTokenFail: true },
    query: null
  }
  if (returnurl) route.query = { returnurl }
  router.push(route)
}

const responseHandler = (response) => {
  store.commit('setAjaxRequestPending', false)
  store.commit('setLastAjaxResult', 'ok')
  return response
}

axiosInstance.interceptors.request.use(auth, error => Promise.reject(error))
axiosInstance.interceptors.response.use(responseHandler, refreshTokenOrFail)

export default axiosInstance
